import { render, staticRenderFns } from "./DetailedViewDatesBlock.vue?vue&type=template&id=79ec3a06&"
import script from "./DetailedViewDatesBlock.vue?vue&type=script&lang=js&"
export * from "./DetailedViewDatesBlock.vue?vue&type=script&lang=js&"
import style0 from "./DetailedViewDatesBlock.vue?vue&type=style&index=0&id=79ec3a06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports